<template>
  <div class="v2-loader" v-if="newDesign">
    <div class="v2-loader__wrapper">
      <div class="v2-loader__spinner">
        <svg v-if="newDesign" class="new-crezu-loader" width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse opacity="0.54" cx="84.1964" cy="45.021" rx="5.80089" ry="5.80365" transform="rotate(90 84.1964 45.021)" fill="white"/>
          <ellipse opacity="0.6" rx="5.8013" ry="5.80325" transform="matrix(-0.382814 0.923825 -0.923954 -0.382504 81.2277 59.9997)" fill="white"/>
          <circle opacity="0.66" r="5.80227" transform="matrix(-0.707275 0.706939 -0.707275 -0.706939 72.7224 72.7085)" fill="white"/>
          <ellipse opacity="0.72" rx="5.80324" ry="5.8013" transform="matrix(-0.922518 0.385953 -0.386265 -0.922388 60.026 81.2022)" fill="white"/>
          <ellipse opacity="0.78" rx="5.80365" ry="5.80089" transform="matrix(-0.999993 -0.0038584 0.00386206 -0.999993 44.8672 84.1768)" fill="white"/>
          <ellipse opacity="0.84" rx="5.80324" ry="5.8013" transform="matrix(-0.922518 -0.385953 0.386265 -0.922388 29.8859 81.1475)" fill="white"/>
          <ellipse opacity="0.9" rx="5.80226" ry="5.80228" transform="matrix(-0.704702 -0.709504 0.709839 -0.704364 17.2144 72.6014)" fill="white"/>
          <ellipse rx="5.8013" ry="5.80325" transform="matrix(-0.382814 -0.923825 0.923954 -0.382504 8.79315 59.9453)" fill="white"/>
          <ellipse opacity="0.06" cx="5.84826" cy="44.7123" rx="5.80089" ry="5.80365" transform="rotate(-89.5577 5.84826 44.7123)" fill="white"/>
          <ellipse opacity="0.12" rx="5.80131" ry="5.80323" transform="matrix(0.389709 -0.920938 0.921071 0.389395 8.9204 29.792)" fill="white"/>
          <ellipse opacity="0.18" rx="5.80229" ry="5.80225" transform="matrix(0.712393 -0.701781 0.702119 0.712059 17.5128 17.1431)" fill="white"/>
          <ellipse opacity="0.24" rx="5.80326" ry="5.80128" transform="matrix(0.926788 -0.375586 0.375892 0.926663 30.3092 8.72026)" fill="white"/>
          <ellipse opacity="0.3" rx="5.80365" ry="5.80089" transform="matrix(0.999933 0.0115746 -0.0115856 0.999933 45.4842 5.86768)" fill="white"/>
          <ellipse opacity="0.36" rx="5.80322" ry="5.80132" transform="matrix(0.919611 0.39283 -0.393146 0.919476 60.3674 8.98324)" fill="white"/>
          <ellipse opacity="0.42" rx="5.80224" ry="5.8023" transform="matrix(0.699527 0.714606 -0.714938 0.699188 73.008 17.6219)" fill="white"/>
          <ellipse opacity="0.48" rx="5.80127" ry="5.80327" transform="matrix(0.372421 0.928064 -0.928186 0.372116 81.3934 30.4484)" fill="white"/>
        </svg>
      </div>
      <div class="v2-loader__text">
        <span v-if="preloaderPhrases.length">{{preloaderPhrases[Math.floor(Math.random() * 4)]}}</span>
      </div>
    </div>
  </div>
  <div v-else id="loader-new" style="background: rgba(255,255,255,0.7) !important;display: table">
    <div style="text-align: center;display: table-cell;vertical-align: middle;">
      <div>
        <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="64px" height="64px" viewBox="0 0 128 128" xml:space="preserve">
          <g transform="rotate(270 64 64)">
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#000"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#e5e5e5" transform="rotate(30 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#e5e5e5" transform="rotate(60 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#e5e5e5" transform="rotate(90 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#cecece" transform="rotate(120 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#b7b7b7" transform="rotate(150 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#9f9f9f" transform="rotate(180 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#898989" transform="rotate(210 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#727272" transform="rotate(240 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#5c5c5c" transform="rotate(270 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#444" transform="rotate(300 64 64)"></path>
            <path d="M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z" fill="#2e2e2e" transform="rotate(330 64 64)"></path>
            <animateTransform attributeName="transform" type="rotate" values="0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64" calcMode="discrete" dur="1080ms" repeatCount="indefinite"></animateTransform>
          </g>
        </svg>
      </div>
      <div>
        <span v-if="preloaderPhrases.length" id="loader-text">{{preloaderPhrases[Math.floor(Math.random() * 4)]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Preloader',
  data () {
    return {
      newDesign: window.newDesign
    }
  },
  computed: mapState({
    preloaderPhrases: state => state.config.params.preloader_phrases
  })
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/preloader";
</style>



// WEBPACK FOOTER //
// src/components/preloader.vue